export function OarArmida() {
  return (
    <svg
      width="312.72833"
      height="650"
      viewBox="0 0 82.742702 171.97917"
      version="1.1"
      id="armida"
    >
      <defs id="defs1" />
      <g id="layer1" transform="translate(0.19270325)">
        <rect
          fill="#000080"
          id="rect1"
          width="82.742706"
          height="171.97917"
          x="-0.19270325"
          y="1.527482e-14"
        />
        <rect
          fill="#ffffff"
          id="rect2"
          width="82.814583"
          height="52.916668"
          x="-0.13229176"
          y="53.212658"
        />
      </g>
    </svg>
  );
}
